/**
 * UiCheckPreview - 本次三项改动的本地验收页（仅开发预览，不进入正式导航）
 *
 * 访问：
 *   http://localhost:3005/?preview=ui-check
 *
 * 覆盖：
 *   1. 「我的创建」列表的检索 / 状态 / 时间筛选栏
 *   2. 营养成分表「每xx克」可编辑（数值 + 单位）
 *
 * 说明：列表数据依赖登录态，未登录时会走错误分支，但筛选栏位于错误提示之上，
 *      仍然可用于核对布局与交互控件。
 */

import React, { useState } from 'react';
import { LabelList } from './Profile/components/LabelList';
import NutritionTable from '../components/templates/NutritionTable';
import Footer from '../layouts/Footer';
import './styles/UiCheckPreview.css';

const MOCK_NUTRITION = {
  basis: { value: 100, unit: '克' },
  items: [
    { name: '能量', per100g: '268', unit: 'kJ', nrv: '3%' },
    { name: '蛋白质', per100g: '3.2', unit: 'g', nrv: '5%' },
    { name: '脂肪', per100g: '3.6', unit: 'g', nrv: '6%' },
    { name: '碳水化合物', per100g: '4.5', unit: 'g', nrv: '2%' },
    { name: '钠', per100g: '52', unit: 'mg', nrv: '3%' },
  ],
};

export default function UiCheckPreview() {
  const [nutrition, setNutrition] = useState(MOCK_NUTRITION);

  return (
    <div className="ui-check-page">
      <section className="ui-check-block">
        <h2>① 「我的创建」检索 + 筛选</h2>
        <p className="ui-check-tip">
          名称关键词 / 状态（含条数统计）/ 时间范围，筛选后可一键清空；列表区域已放宽到 1680px。
        </p>
        <div className="ui-check-list-wrap">
          <LabelList onCreateLabel={() => {}} onEditLabel={() => {}} />
        </div>
      </section>

      <section className="ui-check-block">
        <h2>② 营养成分表「每 __ 克」可编辑</h2>
        <p className="ui-check-tip">
          默认 100 克；数值与单位都可改，右侧预览同步变化（当前：每
          {nutrition.basis.value}
          {nutrition.basis.unit}）。
        </p>
        <div className="ui-check-nutrition">
          <NutritionTable
            data={nutrition}
            onUpdate={(next) => setNutrition(next)}
            onOpenStyle={() => {}}
          />
        </div>
      </section>

      <section className="ui-check-block">
        <h2>③ 页脚标识（原公司 logo 已替换为通用标签图标）</h2>
        <Footer />
      </section>
    </div>
  );
}
